import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchStepsData,
	fetchStepsDataSuccess,
	fetchStepsDataFailure
} from '../actions/actions';

import { mainApi } from '../api/mainApi';

function* loadStepsData() {
	try {
		const data = yield call(mainApi('https://wpwizardapi.siteground.com/docs/steps.json'));
		yield put(fetchStepsDataSuccess(data));
	} catch (e) {
		console.error(`${e}`, e);
		yield put(fetchStepsDataFailure(e));
	}
}

function* steps(): any {
	yield takeLatest(fetchStepsData, loadStepsData);
}

export default steps;
